import { Button, MenuItem, Paper, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Formik } from 'formik';
import { useMemo, useState } from 'react';
import { useRecoilStateLoadable, useRecoilValueLoadable } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import {
  FormikSelect,
  FormikTextField,
} from '../../../common/formik-material-ui';
import { phoneSearch } from '../../../recoil/atoms/phoneSearch';
import { phoneNumberSearch } from '../../../recoil/selectors/phoneNumberSearch';
import dataTableScss from '../../modules/Manage/pages/queues-table/data-table.module.css';
import { countries } from '../countries';
import { BuyAgentNumberModal } from './BuyAgentNumberModal';

import { GridRenderCellParams, GridSortModel } from '@mui/x-data-grid';
import * as Yup from 'yup';
import { trackSearchMyNumbers } from '../../../common/userTracking';
import { agentUserId } from '../../../recoil/atoms/agentUserId';
import { IUserAtom, user } from '../../../recoil/atoms/user';
import {
  DataTable,
  IColDef,
} from '../../modules/Manage/pages/queues-table/DataTable';
import { ModalWithStyles } from './ModalWithStyles';

function priceFormatter(params: GridRenderCellParams) {
  return <b>${params.row.monthly_rental_rate}</b>;
}
function mmsFormatter(params: GridRenderCellParams) {
  if (params.row.mmsEnabled) {
    return <b>Yes</b>;
  } else {
    return <b>No</b>;
  }
}
function smsFormatter(params: GridRenderCellParams) {
  if (params.row.smsEnabled) {
    return <b>Yes</b>;
  } else {
    return <b>No</b>;
  }
}
export function AddAgentNumberModal(props) {
  const useStyles = makeStyles((theme: Theme) => ({
    field: {
      marginTop: theme.spacing(1), // space between fields
      marginBottom: theme.spacing(1), // space between fields
    },
    add: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      marginLeft: theme.spacing(1), // space between fields
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    button: {
      // color: theme.palette.primary.contrastText,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      '& .MuiButton-label': {
        padding: 2,
      },
    },
  }));

  const classes = useStyles();
  const sortModel = [
    { field: 'number', sort: 'desc' },
  ] /* satisfies */ as GridSortModel;
  const agentUserIdAtom = useRecoilValueLoadable(agentUserId);
  const [, setForm] = useRecoilStateLoadable(phoneSearch);
  const phoneNumbers = useRecoilValueLoadable(phoneNumberSearch);
  // console.log(phoneNumbers, 'phone number searchg selectror ');
  // state for buy number modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // number passed to buy number modal
  const [rowOfNumber, setRowOfNumber] = useState({});

  function handleBuyNumber(row) {
    setRowOfNumber(row);
    handleShow();
  }
  function buyNumberFormatter(params) {
    return (
      <Button
        className={classes.button}
        onClick={() => {
          handleBuyNumber(params.row);
        }}
        variant="contained"
        color="primary"
      >
        Buy
      </Button>
    );
  }
  const columns = [
    {
      field: 'number',
      headerName: 'Number',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
    },
    {
      field: 'region',
      headerName: 'Region',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
    },
    {
      field: 'monthly_rental_rate',
      headerName: 'Price',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: priceFormatter,
    },
    {
      field: 'mmsEnabled',
      headerName: 'MMS',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: mmsFormatter,
    },
    {
      field: 'smsEnabled',
      headerName: 'SMS',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: smsFormatter,
    },
    {
      field: 'type',
      headerName: 'Buy',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: buyNumberFormatter,
    },
  ] /* satisfies */ as IColDef[];

  const customPaginationActions = (props) => {
    return null;
  };

  const editable = useMemo(
    () =>
      phoneNumbers?.state === 'hasValue' &&
      phoneNumbers?.contents?.data?.response?.objects.length
        ? phoneNumbers.contents.data.response.objects.map((o) => ({
            ...o,
            id: uuidv4(),
          }))
        : [],
    [phoneNumbers]
  );

  const smsOptions = [
    {
      code: 'Y',
      name: 'Yes',
    },
    {
      code: 'E',
      name: 'Either',
    },
  ];
  const phoneNumberSearchShema = useMemo(
    () =>
      Yup.object({
        country: Yup.string().required('Required'),
        areaCode: Yup.number().typeError('Must be a number'),
        // .required('Required'),
        smsAble: Yup.string().required('Required'),
      }),
    []
  );
  const [userLoadable] = useRecoilStateLoadable<
    IUserAtom | Record<string, any>
  >(user);
  const userAtom = userLoadable.contents as IUserAtom;
  const loginUser = userAtom?.user ?? {};
  return (
    <>
      <Paper elevation={0} square={true}>
        <Formik
          onSubmit={(values, actions) => {
            const { country, areaCode, smsAble } = values;
            setForm({
              cc: country,
              pattern: areaCode,
              sms: smsAble,
            });
          }}
          validationSchema={phoneNumberSearchShema}
          initialValues={{
            country: 'US',
            areaCode: '',
            smsAble: 'Y',
          }}
        >
          {(formik) => (
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title={`Add Number for ${agentUserIdAtom.contents.name}`}
              aria-labelledby="example-modal-sizes-title-lg"
              show={props.show}
              onHide={() => {
                props.handleClose();
                formik.resetForm({});
              }}
              isSubmitting={phoneNumbers.state === 'loading'}
              isLoading={phoneNumbers.state === 'loading'}
              footerComponent={
                <div>
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="inherit"
                    disableElevation
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                  <Button
                    className={classes.add}
                    variant="contained"
                    onClick={() => {
                      if (
                        window.location.pathname ===
                        `/my-profile/${loginUser.userid}/numbers`
                      ) {
                        trackSearchMyNumbers();
                      }
                      formik.handleSubmit();
                    }}
                  >
                    Search For Number
                  </Button>
                </div>
              }
            >
              <div className="row">
                <div className="col-lg-6">
                  <FormikSelect
                    name="country"
                    className={classes.field}
                    formik={formik}
                    fullWidth
                    label="Country"
                    size="small"
                    variant="outlined"
                  >
                    {countries.map((country, index) => (
                      <MenuItem key={index} value={country.code}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </div>

                <div className="col-lg-6">
                  <FormikTextField
                    name="areaCode"
                    className={classes.field}
                    formik={formik}
                    // autoFocus={true}
                    fullWidth
                    label="Area Code"
                    size="small"
                    // required
                    variant="outlined"
                  />

                  <FormikSelect
                    name="smsAble"
                    className={classes.field}
                    formik={formik}
                    fullWidth
                    label="SMSable"
                    size="small"
                    variant="outlined"
                  >
                    {smsOptions.map((sms, index) => (
                      <MenuItem key={index} value={sms.code}>
                        {sms.name}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </div>
              </div>
              <div>
                {phoneNumbers?.contents.data?.message && (
                  <b>{phoneNumbers?.contents.data?.message}</b>
                )}
                {phoneNumbers?.contents.data &&
                  !phoneNumbers?.contents.data?.message && (
                    <DataTable
                      loading={phoneNumbers.state === 'loading'}
                      rows={editable}
                      columns={columns}
                      sortModel={sortModel}
                      hideSortIcon={true}
                      customPaginationActions={customPaginationActions}
                      hideRowsPerPageOptions={true}
                    />
                  )}
              </div>
            </ModalWithStyles>
          )}
        </Formik>
      </Paper>

      <BuyAgentNumberModal
        closeOuterModal={props.handleClose}
        row={rowOfNumber}
        handleClose={handleClose}
        handleShow={handleShow}
        show={show}
        setRefetchToggleForNumbers={props.setRefetchToggleForNumbers}
      />
    </>
  );
}
